<div
  class="min-h-screen"
  [ngStyle]="getBackgroundStyles()"
  [style.backgroundColor]="backgroundColor | contentBuilderColor"
>
  <app-block-list [blockIdList]="body"></app-block-list>
  <router-outlet></router-outlet>
</div>
